export const courierApi = {
  cost: 'marketplace-courier-write/v1/items-marketplace/calculate-shipping-cost',
  order: 'marketplace-order-read-services/v1/orders-marketplace-provider/status-detail',
  address: 'customerEndpoint/findCustomerDaneCodeCityByIdCity',
};
